var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroImgKula(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6082 29.7968C25.1241 29.7968 32.0276 23.3153 32.0276 15.3199C32.0276 7.32447 25.1241 0.842926 16.6082 0.842926C8.09224 0.842926 1.18872 7.32447 1.18872 15.3199C1.18872 23.3153 8.09224 29.7968 16.6082 29.7968Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImgKula);
export default __webpack_public_path__ + "static/media/hero-img-kula.87e0e3b41c6508633bad2d09a71051f7.svg";
export { ForwardRef as ReactComponent };